import { Card, Typography, Container, Box } from "@mui/material";
import ActionButton from "./ActionButton";
import PropTypes from "prop-types";
import { useClient } from "../../context/ClientProvider";
/**
 * Account link card
 * @param {*} param0
 * @returns
 */
function ActionLinkCard({
  id,
  backgroundColor,
  textColor,
  title,
  description,
  disposableIncome,
  buttonId,
  buttonColor,
  borderColor,
  reviewDate,
  buttonTextColor,
  buttonTitle,
  hoverColor,
  hoverTextColor,
  target = "/",
  icon,
}) {
  const { useGetConfig } = useClient();
  const clientConfig = useGetConfig()?.clientConfig;
  const contactUsDataPerClient = clientConfig?.layout?.unauthenticatedPages.contactUs;

  return (
    <Card
      id={id}
      sx={{
        backgroundColor: `${backgroundColor}`,
        color: `${textColor}`,
        borderRadius: 0,
      }}
    >
      <span
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: 20,
            ml: 2,
            pt: 1.2,
            flexGrow: 1,
          }}
        >
          {title}
        </Typography>

        {icon && (
          <span style={{ marginRight: 16 }} aria-label='info'>
            {icon}
          </span>
        )}
      </span>
      <Typography
        sx={{
          fontSize: 16,
          mt: 1.5,
          mx: 2,
        }}
      >
        {description}
      </Typography>
      {disposableIncome !== undefined && (
        <Typography
          sx={{
            fontSize: 16,
            mt: 1.5,
            mx: 2,
          }}
        >
          {disposableIncome >= 0
            ? "If your financial situation has changed, you can click the button below to complete a new form."
            : "If your financial situation has changed, you can click the button below to complete a new form or if you prefer, you can speak to a helpful member of our team."}
        </Typography>
      )}
      {reviewDate && <Typography>{reviewDate}</Typography>}
      <Container sx={{ textAlign: "center", pt: 2, pb: 3 }}>
        <ActionButton
          id={buttonId}
          buttonColor={buttonColor}
          borderColor={borderColor}
          buttonTextColor={buttonTextColor}
          buttonTitle={buttonTitle}
          hoverColor={hoverColor}
          hoverTextColor={hoverTextColor}
          target={target}
          variant='outlined'
        />
        <Box sx={{ mt: 2 }}>
          {disposableIncome < 0 && (
            <ActionButton
              id={buttonId}
              buttonColor="secondary.main"
              buttonTextColor="secondary.contrastText"
              buttonTitle='Call Us'
              hoverColor="primary.dark"
              hoverTextColor={hoverTextColor}
              target={`tel:${contactUsDataPerClient?.phoneUs?.phoneNumber ?? ''}`}
              outlined={true}
            />
          )}
        </Box>
      </Container>
    </Card>
  );
}

ActionLinkCard.propTypes = {
  id: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  title: PropTypes.node,
  description: PropTypes.string,
  disposableIncome: PropTypes.number,
  buttonId: PropTypes.string,
  buttonColor: PropTypes.string,
  borderColor: PropTypes.string,
  reviewDate: PropTypes.string,
  buttonTextColor: PropTypes.string,
  buttonTitle: PropTypes.string,
  hoverColor: PropTypes.string,
  hoverTextColor: PropTypes.string,
  target: PropTypes.string,
  icon: PropTypes.node,
};

export default ActionLinkCard;
